import type { RouteLocationNormalized } from 'vue-router'
import { useRoute } from '#imports'
import { getGtmContentGroup } from '~/utils/getGtmContentGroup'

/**
 * GA4 `content_group` of the current page for the search events (KFT-4280).
 * Sent on the events themselves: the `nuxtRoute` pageview push that also sets
 * it runs 2s after a navigation, too late for a search started right away.
 * Returns a getter so the value is read when the event is sent.
 */
export const useSearchContentGroup = () => {
  const route = useRoute()
  return () =>
    String(getGtmContentGroup(route as RouteLocationNormalized) ?? '')
}
